import React from 'react';
import PropTypes from 'prop-types';
import { resolveCardholderFooterLinks } from 'shared-components/src/utils/footerLinks';
import { CamsFooter, FooterLinksGroup, FooterCopyright } from './styles';

/**
 * Shared footer component for CAMS pages (Login, Register)
 * Displays footer links and copyright information from theme
 */
const CamsPageFooter = ({ theme, locale }) => {
  const currentLocale = locale || 'en';

  // Cardholder portal footer links, ordered and per-language. These used to read the
  // balance checker's cbc_footer config, which meant editing one silently changed the other.
  const footerLinks = resolveCardholderFooterLinks(theme?.brand?.cardholder_footer, currentLocale);

  const companyName = theme?.brand?.copyright_company_name;

  if (footerLinks.length === 0 && !companyName) {
    return null;
  }

  return (
    <CamsFooter>
      {footerLinks.length > 0 && (
        <FooterLinksGroup>
          {footerLinks.map((link, index) => (
            <React.Fragment key={link.key || link.url}>
              <a
                href={link.url}
                target={link.external ? '_blank' : undefined}
                rel={link.external ? 'noopener noreferrer' : undefined}
              >
                {link.title}
              </a>
              {index < footerLinks.length - 1 && <span>|</span>}
            </React.Fragment>
          ))}
        </FooterLinksGroup>
      )}
      {companyName && (
        <FooterCopyright>
          &copy; {new Date().getFullYear()} {companyName}
        </FooterCopyright>
      )}
    </CamsFooter>
  );
};

CamsPageFooter.propTypes = {
  theme: PropTypes.object,
  locale: PropTypes.string,
};

export default CamsPageFooter;
